import React from 'react';
import { MdOutlineAssessment, MdCloudDone, MdManageAccounts, MdOutlineGavel, MdLoop } from 'react-icons/md';
import img1 from '../../../../assets/img/Services/IAMSecuritySolutions/img1.jpg';

export default function MainSection2() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="flex flex-col mb-6 justify-center lg:justify-center lg:flex-row md:mb-8">
        <h2 className="max-w-lg mb-5 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
          <span className="inline-block mb-1 sm:mb-4">Our Offerings</span>
          <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Centralized Cloud Identity Management
            </h1>
            <p className="text-lg text-gray-600">
            Simplify and centralize identity management for your multi-cloud and hybrid environments.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 - Strategy & Roadmap */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineAssessment className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Unified Identity System</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Create a unified identity system that integrates seamlessly across all cloud platforms, including AWS, Azure, and Google Cloud.
              </p>
            </div>

            {/* Feature 2 - IAM Implementation */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdCloudDone className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Centralized Visibility</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Enable single-pane-of-glass visibility into user access and identity lifecycles.
              </p>
            </div>

            {/* Feature 3 - Access Management */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdManageAccounts className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Automated Provisioning</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Automate user provisioning and de-provisioning to ensure secure and efficient onboarding and offboarding.
              </p>
            </div>
          </div>
        </div>

        {/* Image Section */}
        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Cloud IAM Implementation"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  );
}
